import type { ReactNode } from 'react'

import { Page } from '@/components/layout'
import { LanguageMenu, ThemeMenu } from '@/features/nav/preference-menus'

/** The auth pages' frame: a narrow page with the preference menus in the top-right corner. */
export function AuthPage({ children }: { children: ReactNode }) {
  return (
    <Page width="sm" className="pt-10">
      <div className="mb-2 flex justify-end gap-1">
        <LanguageMenu />
        <ThemeMenu />
      </div>
      {children}
    </Page>
  )
}
